import PolicyLayout from '../../components/PolicyLayout';

export default function RefundPage() {
  return (
    <PolicyLayout title="Cancellation and Refund Policy" lastUpdated="February 2026">
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">1. Cancellation Policy</h2>
        <p className="text-slate-400 mb-4">
          Due to the instant nature of our printing service, cancellations are limited:
        </p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>
            <strong>Before Payment:</strong> You can cancel anytime before completing payment
          </li>
          <li>
            <strong>After Payment:</strong> Once payment is confirmed, the print job begins
            immediately and cannot be cancelled
          </li>
          <li>
            <strong>Cash on Delivery:</strong> COD orders can be cancelled before collection
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">2. Refund Eligibility</h2>
        <p className="text-slate-400 mb-4">Refunds are available in the following cases:</p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>
            <strong>Print Quality Issues:</strong> If the print quality is significantly poor due to
            equipment malfunction
          </li>
          <li>
            <strong>Wrong Print Settings:</strong> If the print does not match the selected
            preferences due to system error
          </li>
          <li>
            <strong>Technical Failures:</strong> If payment was charged but the print job failed to
            process
          </li>
          <li>
            <strong>Duplicate Charges:</strong> If you were charged multiple times for the same
            order
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">3. Non-Refundable Cases</h2>
        <p className="text-slate-400 mb-4">Refunds will NOT be provided for:</p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>Incorrect file uploads by the user</li>
          <li>Wrong print settings selected by the user</li>
          <li>Uncollected prints after 24 hours</li>
          <li>Issues with the original document (low resolution, formatting errors)</li>
          <li>Change of mind after printing has begun</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">4. How to Request a Refund</h2>
        <p className="text-slate-400 mb-4">To request a refund:</p>
        <ol className="list-decimal pl-6 text-slate-400 space-y-2">
          <li>
            Email us at{' '}
            <a href="mailto:info@statiomart.com" className="text-indigo-400 hover:underline">
              info@statiomart.com
            </a>{' '}
            within 24 hours of the transaction
          </li>
          <li>Include your transaction ID or order reference</li>
          <li>Describe the issue with supporting evidence (photos if applicable)</li>
          <li>Our team will review and respond within 2-3 business days</li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">5. Refund Processing</h2>
        <p className="text-slate-400 mb-4">Once a refund is approved:</p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>Refunds will be processed to the original payment method</li>
          <li>Credit/Debit card refunds: 5-7 business days</li>
          <li>UPI refunds: 1-3 business days</li>
          <li>Net banking refunds: 5-7 business days</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">6. Partial Refunds</h2>
        <p className="text-slate-400">
          In cases where only part of the order was affected (e.g., some pages printed incorrectly),
          we may offer a partial refund proportional to the affected portion of the order.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">7. Contact Us</h2>
        <p className="text-slate-400">
          For refund inquiries, please contact us at{' '}
          <a href="mailto:info@statiomart.com" className="text-indigo-400 hover:underline">
            info@statiomart.com
          </a>
        </p>
      </section>
    </PolicyLayout>
  );
}
